import { defineMessages } from '@atlassian/jira-intl';

// eslint-disable-next-line formatjs/no-multiple-plurals
export const messages = defineMessages({
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-one-description-non-final',
		defaultMessage: `
Out of {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}}, {syncedIntegrationCount, plural, one {{syncedIntegrationCount} integration is} other {{syncedIntegrationCount} integrations are}}  fully synced with Jira Service Management.
{notSyncedIntegrationCount, plural, =0 {} one {{notSyncedIntegrationCount} integration wasn't synced either because it isn't supported in Jira Service Management or is a chat integration that you’ll need to configure manually.} other {{notSyncedIntegrationCount} integrations weren’t synced either because they aren’t supported in Jira Service Management or are chat integrations that you’ll need to configure manually.}} \n
To manage your integrations, go to **Settings > Products > Integrations**.
        `,
		description: 'Transition home integrations step task one description',
	},
	taskOneActionButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-one-action-button-non-final',
		defaultMessage: 'View your integrations',
		description: 'Transition home integrations step task one action button',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-two-description-non-final',
		defaultMessage: `
Your Opsgenie’s integrations with Jira and Jira Service Management are now available as Sync in **Settings > Products > Syncs**.\n
You can set up more syncs with your service and software projects on the same site, or a different site. [Read more about sync](https://support.atlassian.com/jira-service-management-cloud/docs/what-is-sync/).
        `,
		description: 'Transition home integrations step task one description',
	},
	taskThreeDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-three-description-non-final',
		defaultMessage:
			"These are Opsgenie integrations with products that are unavailable for addition in Jira Service Management. You can edit existing instances that are synced with Jira Service Management but can't add new ones.",
		description: 'Transition home integrations step task three description',
	},
	taskFourDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-four-description-non-final',
		defaultMessage: `
These integrations weren’t shifted from Opsgenie to Jira Service Management as we’re ending support for some products. They’ll still be operational until you turn off Opsgenie.`,
		description: 'Transition home integrations step task four description',
	},
	taskFiveDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-five-description-non-final',
		defaultMessage: `
All {incomingCallIntegrations, plural, one {{incomingCallIntegrations} incoming call integration} other {{incomingCallIntegrations} incoming call integrations}} incoming call integrations in Opsgenie are now available in Jira Service Management as a native feature, not integrations. You’ll find it in **Settings > Products > Incoming call routing**.`,
		description: 'Transition home integrations step task five description',
	},
	taskFiveActionButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.integrations-step.task-five-action-button-non-final',
		defaultMessage: 'Go to incoming call routing',
		description: 'Transition home integrations step task five action button',
	},
});
